<!-- Tabla -->
<div class="border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden">
  <div class="overflow-x-auto">
    <table class="min-w-full text-left whitespace-nowrap">
      <thead class="bg-gray-50 dark:bg-gray-800/50 border-b border-gray-200 dark:border-gray-700">
        <tr>
          <th class="px-5 py-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Nombre del Contacto</th>
          <th class="px-5 py-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Correo Electrónico</th>
          <th class="px-5 py-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Fecha de Inclusión</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-100 dark:divide-gray-800 bg-white dark:bg-gray-900">

        @if (isLoading) {
        <tr>
          <td colspan="3" class="px-6 py-12 text-center">
            <div class="animate-spin rounded-full h-7 w-7 border-b-2 border-brand-500 mx-auto mb-3"></div>
            <span class="text-sm text-gray-500 dark:text-gray-400">Cargando miembros...</span>
          </td>
        </tr>
        }

        @if (!isLoading && members.length === 0) {
        <tr>
          <td colspan="3" class="px-6 py-16 text-center">
            <div class="w-14 h-14 bg-gray-50 dark:bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-4 border border-gray-100 dark:border-gray-700">
              <svg class="w-7 h-7 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
            </div>
            <p class="text-sm font-semibold text-gray-700 dark:text-gray-300">No hay contactos en esta lista</p>
            <p class="text-xs text-gray-400 dark:text-gray-500 mt-1">
              {{ segmentType === 'DYNAMIC'
                ? 'Revisa las reglas de filtrado o ejecuta una evaluación.'
                : 'Edita el segmento para añadir contactos manualmente.' }}
            </p>
          </td>
        </tr>
        }

        @for (member of members; track member.id) {
        <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">
          <td class="px-5 py-3.5">
            <div class="flex items-center gap-3">
              <div class="h-8 w-8 rounded-full bg-brand-100 dark:bg-brand-900/30 text-brand-600 dark:text-brand-400 flex items-center justify-center font-semibold text-xs flex-shrink-0">
                {{ (member.contact.name || '')[0]?.toUpperCase() || '?' }}
              </div>
              <span class="text-sm font-medium text-gray-900 dark:text-white">{{ member.contact.name }}</span>
            </div>
          </td>
          <td class="px-5 py-3.5 text-sm text-gray-500 dark:text-gray-400">{{ member.contact.email || '—' }}</td>
          <td class="px-5 py-3.5 text-sm text-gray-500 dark:text-gray-400">{{ member.datetimeCreated | datetime }}</td>
        </tr>
        }

      </tbody>
    </table>
  </div>

  <!-- Paginación -->
  @if (totalElements > size) {
  <div class="px-5 py-3.5 border-t border-gray-100 dark:border-gray-800 flex items-center justify-between bg-gray-50/50 dark:bg-gray-800/30">
    <span class="text-xs text-gray-500 dark:text-gray-400">
      Página {{ page + 1 }} de {{ totalPages }} · {{ totalElements }} contactos
    </span>
    <div class="flex gap-2">
      <button (click)="previousPage()" [disabled]="page === 0"
        class="px-3 py-1.5 text-xs rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        Anterior
      </button>
      <button (click)="nextPage()" [disabled]="page >= totalPages - 1"
        class="px-3 py-1.5 text-xs rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        Siguiente
      </button>
    </div>
  </div>
  }
</div>
